import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { formatNull } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';
import WarningPanel from '../WarningPanel';

const DeactivatedAccountsTable = () => {
    const { openTimeModal } = useTimeModal();
    const [usersWithoutAccess, setUsersWithoutAccess] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    const [reload, setReload] = React.useState(true);

    const [limitForView, setLimitForView] = React.useState(50);
    const [visibilityBtn, setVisibilityBtn] = React.useState(false);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        axios.get(`/api/users?approval=Отключен&limitForView=${limitForView}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                setWarning('В данный момент деактивированные учётные записи отсутствуют');
                setUsersWithoutAccess([]);
                setVisibilityBtn(false);
            } else {
                setWarning('');
                setUsersWithoutAccess(response.data);
                setVisibilityBtn(response.data.length >= limitForView);
            }
        })
        .catch((error) => {
            console.error(error);
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
        });
    }, [reload]);

    const [confirmDelete, setConfirmDelete] = React.useState(null);
    const changeApprovalUser = (userIdForDelete) => {      
        const token = localStorage.getItem('token');

        axios.put(`/api/block-unblock-acc?userId=${userIdForDelete}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            setConfirmDelete(null);
            openTimeModal('Учётная запись активирована.', 'success');
            setReload(true);
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`Не удалось активировать учётную запись. ${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
    };

    const handleChangeApprovalClick = (userIdForDelete) => {
        if (confirmDelete === userIdForDelete) {
            changeApprovalUser(userIdForDelete);
        } else {
            setConfirmDelete(userIdForDelete);
        }
    };

    return (
    <div className='pageWrapper'>
        <div className='tableContainer' style={{marginBottom: '20px'}}>
            <div className='tableHeaderWrapper'>
                <div className='tableHeader' style={{gridTemplateColumns: '1fr 1fr 1fr'}}>
                    <div>ФИО</div>
                    <div>Электронная почта</div>
                    <div>Действие</div>
                </div>
            </div>
            {loading ? <LoadingLines count='1' />
            : warning ? <WarningPanel text={warning} inTable={true} />
            : usersWithoutAccess.map((user) => (
                <div className='tableRow nonActive' key={user.id} style={{gridTemplateColumns: '1fr 1fr 1fr'}}>
                    <div>{user.lastname} {user.firstname} {user.surname}</div>
                    <div>{user.email}</div>
                    <div>
                        <button type='button' className='button miniButton' onClick={() => handleChangeApprovalClick(user.id)}>
                            {confirmDelete === user.id ? 'Вы уверены?' : 'Активировать учётную запись'}
                        </button>
                    </div>
                </div>
            ))}
            {visibilityBtn && <span style={{display: 'flex', justifyContent: 'center'}}><button type='button' className='button' onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}>Загрузить ещё</button></span>}
        </div>
    </div>
    )
}

export default DeactivatedAccountsTable;